import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { skontodefinitionenByArtSelector, skontodefinitionenSelector } from 'store/lookups/selector';
import { useSelector } from 'react-redux';
import { MenuPlacement } from 'react-select/src/types';

interface SkontodefinitionProps {
    label: string;
    disabled: boolean;
    value: number;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: number) => void;
}

export const Skontodefinition: React.FC<SkontodefinitionProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'top',
    allowEmpty = false,
    onChange,
}) => {
    const skontodefinitionen = useSelector(skontodefinitionenSelector);
    const skontodefinitionenByArt = useSelector(skontodefinitionenByArtSelector);

    const options = React.useMemo(() => {
        const o = skontodefinitionen
            .filter((skontodefinition) => !skontodefinition.archiv)
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((sd) => ({
                value: sd.art.toString(),
                label: sd.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [skontodefinitionen, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: skontodefinitionenByArt[value]?.text || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value ? parseInt(option?.value, 10) : 0);
                }}
                menuPlacement={menuPlacement}
            />
        </>
    );
};
